import React, { useState, useEffect, useContext } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes/Routes';
import { WebAppProvider } from './contexts/WebAppContext';
import { CsrfProvider, CsrfContext } from './contexts/CsrfSyncContext';
import { setCsrfToken } from './api/axiosConfig';

// Inner component that uses the CSRF context
const AppContent = () => {
  const { csrfToken, isLoading } = useContext(CsrfContext);
  const [tempToken, setTempToken] = useState(sessionStorage.getItem('tempToken') || '');

  // Set CSRF token whenever it changes
  useEffect(() => {
    if (csrfToken && !isLoading) {
      console.log('App: Setting CSRF token from context');
      setCsrfToken(csrfToken);
    }
  }, [csrfToken, isLoading]);

  // Handle storage changes
  useEffect(() => {
    const handleStorageChange = () => {
      setTempToken(sessionStorage.getItem('tempToken') || '');
    };

    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  return (
    <WebAppProvider>
      <Routes tempToken={tempToken} />
    </WebAppProvider>
  );
};

const App = () => {
  return (
    <ChakraProvider>
      <Router>
        <CsrfProvider>
          <AppContent />
        </CsrfProvider>
      </Router>
    </ChakraProvider>
  );
};

export default App;